import { Drawer } from '@mui/material';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import * as S from './sidebar.styles';

export interface ISidebarProps {
    className?: string;
    noMobile?: boolean;
    visible?: boolean;
    onClose: () => void;
}

export const Sidebar: React.FC<ISidebarProps> = props => {
    const { className, children, noMobile, visible, onClose } = props;
    const isMobile = useIsMobile();

    const location = useLocation();

    React.useEffect(() => {
        if (!isMobile) {
            return;
        }

        onClose();
    }, [location]);

    return (
        <Drawer
            sx={{
                width: '248px',
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: '248px',
                    boxSizing: 'border-box',
                },
            }}
            variant="persistent"
            anchor="left"
            open={visible}>
            <S.Sidebar visible={visible} noMobile={noMobile} className={className}>
                {children}
            </S.Sidebar>
        </Drawer>
    );
};

const useIsMobile = () => {
    const [width, setWidth] = React.useState<number>(window.innerWidth);

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    React.useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);

    const isMobile = width <= 768;

    return isMobile;
};
